import { PartialStoryFn, StoryContext } from '@storybook/addons';
import { html } from 'lit-html';
import { ifDefined } from 'lit-html/directives/if-defined';
import { Select } from '../select';
import { Option } from '../types';

export const meta = {
  argTypes: {
    disabled: { table: { disable: true } },
    error: { table: { disable: true } },
    errorMessage: { table: { disable: true } },
    helperText: { table: { disable: true } },
    label: { table: { disable: true } },
    name: { table: { disable: true } },
    placeholder: { table: { disable: true } },
    required: { table: { disable: true } },
    requiredMessage: { table: { disable: true } },
    tooltip: { table: { disable: true } },
    width: { table: { disable: true } },
  },
  args: {
    disabled: false,
    error: false,
    errorMessage: '',
    helperText: '',
    label: 'Select label',
    name: 'select-name',
    placeholder: '',
    required: false,
    requiredMessage: '',
    tooltip: '',
  },
  decorators: [
    (story: PartialStoryFn, { args: { tooltip } }: StoryContext) =>
      html`
        <style type="text/css">
          abds-select {
            padding-top: ${tooltip ? '2rem' : ''};
          }
        </style>
        ${story()}
      `,
  ],
  parameters: {
    controls: {
      hideNoControlsWarning: true,
      sort: 'requiredFirst',
    },
  },
  title: 'Components/Select/',
};

interface Story {
  disabled: Select['disabled'];
  error: Select['error'];
  errorMessage: Select['errorMessage'];
  helperText: Select['helperText'];
  id: string;
  label: Select['label'];
  name: Select['name'];
  options: Partial<Option>[];
  placeholder: Select['placeholder'];
  required: Select['required'];
  requiredMessage: Select['requiredMessage'];
  tooltip: Select['tooltip'];
  width: Select['width'];
}

export const story = ({
  disabled,
  error,
  errorMessage,
  helperText,
  id,
  label,
  name,
  options = [
    { disabled: false, innerHTML: 'First option', label: 'First option', selected: false, value: 'one' },
    { disabled: false, innerHTML: 'Second option', label: 'Second option', selected: false, value: 'two' },
  ],
  placeholder,
  required,
  requiredMessage,
  tooltip,
  width,
}: Partial<Story>) => html`
  <abds-select
    disabled="${ifDefined(disabled || undefined)}"
    error="${ifDefined(error || undefined)}"
    error-message="${ifDefined(errorMessage || undefined)}"
    helper-text="${ifDefined(helperText || undefined)}"
    id="${ifDefined(id || undefined)}"
    label="${ifDefined(label || undefined)}"
    name="${ifDefined(name || undefined)}"
    placeholder="${ifDefined(placeholder || undefined)}"
    required="${ifDefined(required || undefined)}"
    required-message="${ifDefined(requiredMessage || undefined)}"
    tooltip="${ifDefined(tooltip || undefined)}"
    width="${ifDefined(width || undefined)}"
  >
    ${options.map(
      ({ disabled, innerHTML, selected, value }) =>
        html`
          <abds-select-option
            disabled="${ifDefined(disabled || undefined)}"
            selected="${ifDefined(selected || undefined)}"
            value="${ifDefined(value || undefined)}"
          >
            ${innerHTML}
          </abds-select-option>
        `
    )}
  </abds-select>
`;

export default { meta, story };
